<template>
  <div id="sealDetail">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <el-row>
      <el-col :span="14">
        <!-- <h3>用章详情查看页面</h3> -->
        <div class="contain">
          <el-form :model="form" label-width="128px">
            <el-form-item label="申请人" prop="applicantName">
              <el-input
                v-model="form.applicantName"
                class="input"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="申请时间" prop="postTime">
              <el-date-picker
                disabled
                class="input"
                v-model="form.postTime"
                type="datetime"
                placeholder="请选择申请时间"
              >
              </el-date-picker>
              <!-- <el-input prop="form.postTime" class="input" readonly></el-input> -->
            </el-form-item>
            <el-form-item
              label="用章类型"
              prop="sealType"
              v-if="form.newsType == null"
            >
              <el-select
                v-model="form.sealType"
                placeholder="请选择"
                class="input"
                disabled
              >
                <el-option
                  v-for="item in seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="二次审批人" prop="approver">
            <el-select v-model="form.approver" placeholder="请选择" class="input" disabled>
              <el-option v-for="item in approve" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item label="用章事由" prop="reason">
              <!-- <el-input :value="form.cuase" class="input" placeholder="请输入"></el-input> -->
              <el-input
                class="input"
                v-model="form.reason"
                :autosize="{ minRows: 3 }"
                type="textarea"
                disabled
              />
            </el-form-item>
            <el-form-item label="支持导出的材料：" v-if="form.newsType">
              <div>
                <el-checkbox-group v-model="checkedCities">
                  <el-checkbox
                    style="display: block; padding-top: 20px"
                    v-for="city in cities"
                    :label="city.name"
                    :key="city.name"
                    disabled
                  >
                    <div style="display: flex; align-items: flex-start">
                      <div style="width: 180px">{{ city.name }}</div>
                      <div>
                        <el-select
                          size="mini"
                          v-model="city.stype"
                          placeholder="请选择用章类型"
                          disabled
                          value-key="value"
                          multiple
                        >
                          <el-option
                            v-for="item in seal"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="附件" prop="file">
              <!--  <el-upload class="upload_file" v-model="form.file" drag action="https://jsonplaceholder.typicode.com/posts/"
              multiple :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="beforeUpload"
              :file-list="FileList" :on-success="uploadSuccess" :on-change="onChange" :show-file-list="false"
              :on-progress="onProgress">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">最大可上传50M,jpg,jpeg,png,doc,docx,xls,xlsx类型可上传</div>
            </el-upload> -->
              <!-- 附件回显 -->
              <div
                v-for="(item, index) in FileList"
                :key="item.uid"
                class="file_show"
                style="margin-top: 10px"
              >
                <div class="fj" v-if="!item.isShow">
                  <div style="flex: 1">
                    <img
                      src="../../assets/file/word.svg"
                      v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                    />
                    <img
                      src="../../assets/file/xls.svg"
                      v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                    />
                    <img
                      src="../../assets/file/png.svg"
                      v-if="
                        item.ftype == 'jpg' ||
                        item.ftype == 'jpeg' ||
                        item.ftype == 'png'
                      "
                    />
                    <img
                      src="../../assets/file/PDF.svg"
                      v-if="item.ftype == 'pdf'"
                    />
                  </div>
                  <div class="name" style="flex: 9">
                    <div class="fname" style="word-break: break-all">
                      {{ item.name }}
                    </div>
                    <div class="word">
                      <span
                        @click="look(item)"
                        class="look"
                        v-if="
                          $store.state.rolesname.includes('Sealdetail_look')
                        "
                        >预览</span
                      >
                      <span
                        class="down"
                        @click="down(item)"
                        v-if="
                          $store.state.rolesname.includes('Sealdetail_down')
                        "
                        >下载</span
                      >
                      <!-- <span @click="del(item.id)" class="del">删除</span> -->
                    </div>
                  </div>
                </div>
                <!--文件上传进度条-->
                <!-- <div class="uploadprocess" v-else>
                <div>
                  <div class="jdtext">
                    <div class="uploadname">{{ item.name }} </div>
                    <div class="per"> {{ item.curPercentage }}% </div>
                  </div>
                  <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                </div>
              </div> -->
              </div>
            </el-form-item>
            <el-form-item label="关联案件" v-if="form.caseId">
              <el-button @click="detailLink" class="glbtn">
                {{ form.linkName }}</el-button
              >
            </el-form-item>
            <el-form-item label="关联投标" v-if="form.tenderId">
              <el-button @click="detailLink" class="glbtn">
                {{ form.linkName }}</el-button
              >
            </el-form-item>
            <el-form-item label="关联顾问" v-if="form.adviserId">
              <el-button @click="detailLink" class="glbtn">
                {{ form.linkName }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="right">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in logs"
              :key="index"
              color="#3077E6"
              :timestamp="item.reason"
            >
              <div style="display: flex; justify-content: space-between">
                <div>{{ item.content }}</div>
                <div class="time">
                  {{ handleFTime(item.timestamp) }}
                </div>
              </div>
              <div style="color: #909399">{{ item.type }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="right" v-if="processlogs.length > 0">
          <div style="margin-bottom: 10px; font-weight: 600">已审核流程</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in processlogs"
              :key="index"
              color="#3077E6"
              :timestamp="item.reason"
            >
              <div style="display: flex; justify-content: space-between">
                <div>{{ item.type }}</div>

                <div class="time">
                  {{ item.timestamp }}
                </div>
              </div>
              <div style="color: #909399">{{ item.name }} {{ item.con }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="right" v-if="Process.length > 0">
          <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in Process"
              :key="index"
              :timestamp="item.type"
            >
              {{ item.name }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>
    <div class="footer">
      <!-- <el-button type="primary" @click="Post">修改</el-button> -->
      <el-button class="history" @click="history">返回</el-button>
      <el-button
        @click="GetFile"
        class="dayinbtn"
        v-if="form.status == 0 && form.result == 0 && form.isEdit"
      >
        打印
      </el-button>
    </div>
    <!-- //预览dialog -->
    <el-dialog
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="90%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>

    <div class="dayin" ref="das" id="das">
      <div id="casetable">
        <!-- 用印申请表 -->
        <div>
          <div class="case_title center_font" style="line-height: 30px">
            <span class="CheckTitle">新天伦律师事务所用印审批表</span>
          </div>
          <div class="case_main">
            <table class="case_tb" border="1" cellspacing="0" cellpadding="0">
              <tr>
                <td class="td_l" colspan="1" align="center">申请人</td>
                <td class="td_r" colspan="2" align="center">
                  {{ printInfo.applicantName }}
                </td>
                <td class="td_l" align="center" colspan="1">日期</td>
                <td class="td_r" colspan="2" align="center">
                  {{ handleFTime(printInfo.postTime) }}
                </td>
              </tr>
              <tr>
                <td class="td_l" align="center" colspan="1">
                  申请使用印章类型
                </td>
                <td colspan="5" style="width: 70%">
                  <label class="checkbox-label">
                    &nbsp;<input type="checkbox" :checked="gz" id="data1" />
                    公章 </label
                  ><br />
                  <label class="checkbox-label">
                    &nbsp;<input type="checkbox" :checked="ht" id="data2" />
                    合同专用章 </label
                  ><br />
                  <label class="checkbox-label">
                    &nbsp;<input type="checkbox" :checked="fr" id="data3" />
                    法人印章 </label
                  ><br />
                  <label class="checkbox-label">
                    &nbsp;<input type="checkbox" :checked="law" id="data4" />
                    法律意见书专用章 </label
                  ><br />
                  <label class="checkbox-label">
                    &nbsp;<input type="checkbox" :checked="legal" id="data5" />
                    律师函专用章
                  </label>
                </td>
              </tr>
              <tr>
                <td colspan="1" align="center" class="td_l">申请用印事由</td>
                <td colspan="5">&nbsp;{{ printInfo.reason }}</td>
              </tr>
              <tr>
                <td colspan="1" align="center">部门审批</td>
                <td colspan="3" align="center">{{ printInfo.sealdep }}</td>
                <td rowspan="3" colspan="2" align="center">
                  <div id="ercode" data-html2canvas-ignore="true"></div>
                </td>
              </tr>
              <tr>
                <td colspan="1" align="center">领导审批</td>
                <td colspan="3" align="center">{{ printInfo.sealapproval }}</td>
              </tr>
              <tr>
                <td colspan="1" align="center">本人签字</td>
                <td colspan="3" align="center">
                  {{ printInfo.applicantName }}
                </td>
              </tr>
            </table>
          </div>
          <div class="case_row"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { SealDaYin, SealDetail } from '../../api/seal'
import { CaseLog, CaseProcess, CaseApprover } from '../../api/bankrupt'
import { requestDownLoadFile, requestReview } from '../../api/counsel.js'
import { requestDownLoadFile as downfile } from '../../api/seal'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
import mammoth from 'mammoth'
import printJS from 'print-js'
import html2canvas from 'html2canvas'
import QRCode from 'qrcodejs2'
import axios from 'axios'
export default {
  name: 'sealDetail',
  data() {
    return {
      SealId: '',
      isLoading: false,
      next: true, //是否是三级菜单
      form: {
        postTime: '',
        file: []
      },
      logs: [],
      FileList: [],
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ], //合同用章
      approve: [], //二次审批人
      // 文件预览
      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数
      printData: {
        printable: 'casetable',
        // header:'再生资源收货单',
        ignore: ['no-print'],
        type: 'html' // 打印的元素类型
      },
      printInfo: {}, //打印数据
      // qrcode: false,
      gz: false,
      fr: false,
      ht: false,
      law: false,
      legal: false,
      Process: {},
      processlogs: {},
      checkedCities: [],
      cities: null,
      sealbianji: true
    }
  },

  methods: {
    Successlog() {
      CaseApprover({ SealId: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.processlogs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    detailLink() {
      console.log('form', this.form)
      if (this.form.linktype) {
        var caseType = this.form.linktype.typeId.substring(21, 23)
        if (caseType == 12 || caseType == 13) {
          if (
            this.$store.state.rolesname.includes('myDetail') ||
            this.$store.state.rolesname.includes('allDetail')
          ) {
            var type = '破产'
            if (caseType == 13) {
              var type = '破产投标'
            }
            this.$router.push({
              path: 'bankruptdetail',
              name: 'bankruptdetail',
              query: { guid: this.form.caseId, type: type }
            })
          } else {
            this.$message.error('没有页面权限')
          }
        } else {
          if (
            this.$store.state.rolesname.includes('myDetail') ||
            this.$store.state.rolesname.includes('allDetail')
          ) {
            this.$store.commit('setmenustatus', 1)
            this.$router.push({
              path: '/home/case/caseinfo',
              query: {
                guid: this.form.caseId,
                status: this.form.linktype.typeId,
                caseType: caseType
              }
            })
          } else {
            this.$message.error('没有页面权限')
          }
        }
      } else {
        if (this.form.linkName == '投标申请') {
          if (this.$store.state.rolesname.includes('Biddetail')) {
            this.$router.push({
              path: '/home/seal/Biddetail',
              query: {
                guid: this.form.tenderId
              }
            })
          } else {
            this.$message.error('没有页面权限')
          }
        }
        if (this.form.linkName == '顾问申请') {
          if (this.$store.state.rolesname.includes('allCounsel')) {
            // this.$router.push({
            //   path: '/home/counsel/allCounsel'
            //   // query: {
            //   //   guid: this.form.tenderId,
            //   // }
            // })
            var url =
              '/#/home/counsel/allCounsel?companyName=' +
              this.form.companyName +
              '&&id=' +
              this.form.adviserId
            let mywin = window.open(url, 'allCounsel')
            mywin.onload = function () {
              mywin.location.reload()
            }
          } else {
            this.$message.error('没有页面权限')
          }
        }
      }
    },
    GetLog() {
      //获取日志
      CaseLog({ Id: this.SealId }).then((res) => {
        if (res.data.status == 'success') {
          this.logs = res.data.data
          if (this.logs.Reason) {
            this.logs.Reason = JSON.parse(this.logs.Reason).Reason
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    // handleRemove(file, fileList) {//删除成功触发
    //   console.log(file, fileList);
    // },
    // handlePreview(file) {
    //   console.log(file);
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },

    // beforeRemove(file, fileList) {//删除触发
    //   return this.$confirm(`确定移除 ${ file.name }？`);
    // },
    // beforeUpload(file) {
    //   console.log(file)
    //   var type = file.name.substring(file.name.lastIndexOf('.')+1)
    //   const isImg = '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx'.indexOf(type) >= 0;
    //   const isMaxSize = file.size / 1024 / 1024 < 50;
    //   if (!isImg) {
    //     this.$message.error('只能上传jpg,jpeg,png,doc,docx,xls,xlsx格式的文件');
    //   }
    //   if (!isMaxSize) {
    //     this.$message.error('上传大小不能超过50MB！');
    //   }
    //   return isImg && isMaxSize;
    // },
    // uploadSuccess(res,file,fileList) {
    // },
    GetSealDetail() {
      //获取数据
      this.isLoading = true
      SealDetail({ Id: this.SealId }).then((res) => {
        if (res.data.status == 'success') {
          this.form = res.data.data
          if (res.data.data.newsType != null) {
            var typeid = res.data.data.linktype.typeId

            if (this.checkedCities.length > 0) {
              this.checkedCities = []
            }
            // console.log('typeid',typeid)
            if (typeid == '00000000-0000-0000-0001-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '听证出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0001-0001-0002-000000000000') {
              this.cities = [
                {
                  name: '委托协议（辩护）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '为犯罪嫌疑人提供帮助的委托协议', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（侦查）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（检、审）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '会见专用介绍信（嫌疑人 被告人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '取保候审申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '刑事案件代理委托协议（诉讼代理人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（刑事附带民事）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（诉讼代表人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '调查取证申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '延期审理申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '解除强制措施申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '提请收集、调取证据申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '通知证人出庭申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '申请取保候审保证书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师事务所函（侦查）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师会见在押犯罪嫌疑人的函（侦查）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师事务所函（检、审）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0002-0002-0003-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '行政复议出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0003-0003-0004-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0004-0004-0005-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0005-0005-0006-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0006-0006-0007-000000000000') {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0007-0007-0008-000000000000') {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0008-0008-0009-000000000000') {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)

                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0009-0009-0010-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0010-0010-0011-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0011-0011-0012-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0012-0012-0013-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            }
            var oldCities = res.data.data.newsType

            // console.log('cities', this.cities)
            // console.log('oldCities', oldCities)
            oldCities.forEach((val) => {
              this.checkedCities.push(val.name)
              this.cities.forEach((v) => {
                if (v.name == val.name) {
                  v.stype = val.stype
                }
              })
            })
            const cC = new Set(this.checkedCities.map((m) => m))

            var bbk = []
            this.cities.forEach((city, index, array) => {
              // 不包含
              if (!cC.has(city.name)) {
                bbk.push(city.name)
              }
            })
            this.cities = this.cities.filter(function (item) {
              return !bbk.includes(item.name)
            })
          }
          // this.FileList = this.form.file;
          for (var i = 0; i < this.form.file.length; i++) {
            //招标文件、投标方案
            var filename = this.form.file[i].name.substring(
              0,
              this.form.file[i].name.lastIndexOf('.')
            )
            this.FileList.push({
              fid: this.form.file[i].fid,
              name: filename,
              ftype: this.form.file[i].ftype,
              isShow: false,
              curPercentage: 100
            })
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
        this.isLoading = false
      })
    },
    // 时间格式
    handleFTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    history() {
      this.$router.go(-this.times)
    },
    // 打印方法
    daYin(params) {
      // this.createQrcode()
      // var html = document.getElementById("das").innerHTML;
      // var casetable = document.getElementById('casetable')
      // casetable.style.display = 'block'
      // setTimeout(() => {
      //   casetable.style.display = 'none'
      // }, 2000)
      // print.js的onPrintDialogClose事件触发失效,在打印事件触发之前，添加派发一个focus聚焦事件，然后点击取消或打印，清除focus事件。

      let focuser = setInterval(
        () => window.dispatchEvent(new Event('focus')),
        500
      )
      printJS({
        printable: params.printable, // 'casetable', // 标签元素id
        type: params.type || 'html',
        header: params.header, // '表单',
        targetStyles: ['*'],
        documentTitle: this.grcode,
        style: '@page {margin:0 10mm};', // 可选-打印时去掉眉页眉尾
        ignoreElements: params.ignore || [], // ['no-print']
        properties: params.properties || null,
        //打印完成或关闭打印的事件
        onPrintDialogClose: () => {
          //取消打印回调
          //清除focus事件
          clearInterval(focuser)
          // casetable.style.display = 'none'
          this.lsDialog = false
        }
      })
    },

    SealDetail() {
      // this.qrcode=true;
      this.isLoading = true
      SealDaYin({ Id: this.SealId }).then(async (res) => {
        if (res.data.status == 'success') {
          this.printInfo = res.data.data
          if (this.form.sealType.includes('contract')) {
            this.ht = true
          }
          if (this.form.sealType.includes('official')) {
            this.gz = true
          }
          if (this.form.sealType.includes('corporate')) {
            this.fr = true
          }
          if (this.form.sealType.includes('law')) {
            this.law = true
          }
          if (this.form.sealType.includes('legal_letter')) {
            this.legal = true
          }
          this.GetLog()
          this.GetUpload()
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.isLoading = false
          this.$message.error(res.data.message)
        }
      })
    },

    GetFile() {
      this.SealDetail()
    },
    async GetUpload() {
      const name = Math.random().toString(36).substring(2)
      await new Promise((resolve) => setTimeout(resolve, 1000)) // 延迟1秒
      var node = document.getElementById('das') //传入的id名称

      html2canvas(node, {
        scale: 0.9, //缩放比例,默认为1
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        // allowTaint: false,//是否允许跨域图像污染画布
        // useCORS: true,//是否尝试使用CORS从服务器加载图像
        //width: width,//画布的宽度
        // height: height,//画布的高度
        onclone(doc) {
          let e = doc.querySelector('#das')
          e.style.display = 'block'
        }
        // backgroundColor: '#000000',//画布的背景色，默认为透明
      }).then((canvas) => {
        //将canvas转为base64格式
        // var imgUri = canvas.toDataURL("image/png");
        let imgUrl = canvas.toDataURL()
        var blob = this.convertBase64ToBlob(imgUrl)
        // 第一步：将dataUrl转换成Blob
        var fd = new window.FormData()
        // var blob = this.dataURItoBlob(url)
        fd.append('flag', this.$route.query.guid)
        fd.append('filetype', '打印')
        fd.append('file', blob)
        fd.append('name', name)

        // 第二步：上传分享图
        axios({
          url: '/api/Filer/PrintUpload',
          method: 'post',
          headers: {
            Content: 'multipart/form-data'
          },
          data: fd
        })
          // .post(`'/api/Filer/PrintUpload?flag=${this.$route.query.guid}'&filetype=${'打印'}`, fd)
          // .post('/api/Filer/PrintUpload', fd)
          .then((res) => {
            if (res.data.status == '0') {
              var id = res.data.data.substring(
                res.data.data.lastIndexOf('=') + 1
              )
              // var code = 'http://localhost:5276/#/print?id=' + id
              var code = 'https://glxt.ntlawyer.cc/#/print?id=' + id
              this.createQrcode(code)
            } else if (
              res.status == '401' ||
              res.status == '402' ||
              res.status == '403'
            ) {
              this.$message.error(res.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error('上传错误！: casetext:h2c()')
            }
            this.isLoading = false
          })
          .catch(() => {
            this.$message.error('上传错误！')
            this.isLoading = false
          })
        // console.log(this.convertBase64ToBlob(imgUrl))
        // // this.downloadFile(this.convertBase64ToBlob(imgUrl),"1.png");
        // // (this.getObjectURL(this.convertBase64ToBlob(imgUrl)))
        // this.imhurl=this.getObjectURL(this.convertBase64ToBlob(imgUrl))
        // this.createQrcode(imgUrl)
      })
    },
    //生成二维码方法
    createQrcode(code) {
      let container = document.getElementById('ercode')
      if (container.innerHTML) {
        container.innerHTML = ''
      }
      var qrcode = new QRCode(container, {
        text: code, //这里就是二维码扫描后展示的内容了
        width: 100,
        height: 100,
        colorDark: 'black',
        colorLight: 'white',
        correctLevel: QRCode.CorrectLevel.L //二维码的纠错等级，等级越高，二维码呈现越复杂，同时被遮挡的多，也能扫出来
      })
      qrcode.makeCode(code)
      this.daYin(this.printData)
      // const result = new AraleQRCode({
      //       render: "svg",      // 定义生成的类型 'svg' or 'table dom’
      //       text: this.imhurl, // 二维码的链接
      //       size: 150,      //二维码大小
      // });

      // // console.log(this.$refs.das.innerHTML)
      // // 将svg xml文档转换成字符串
      // const svgXml = new XMLSerializer().serializeToString(result);

      // // 将svg字符串转成base64格式，通过 window.btoa方法创建一个 base-64 编码的字符串，进行二次编码解码(encodeURIComponent 字符串进行编码和解码，unescape 进行解码)。
      // const src =
      //       "data:image/svg+xml;base64," +
      //       window.btoa(unescape(encodeURIComponent(svgXml)));

      // // 本地存储图片
      // localStorage.setItem("image", src);
      // this.getImg();
    },
    convertBase64ToBlob(imageEditorBase64) {
      let base64Arr = imageEditorBase64.split(',')
      let imgtype = ''
      let base64String = ''
      if (base64Arr.length > 1) {
        //如果是图片base64，去掉头信息
        base64String = base64Arr[1]
        imgtype = base64Arr[0].substring(
          base64Arr[0].indexOf(':') + 1,
          base64Arr[0].indexOf(';')
        )
      }
      // 将base64解码
      let bytes = atob(base64String)
      //let bytes = base64;
      let bytesCode = new ArrayBuffer(bytes.length)
      // 转换为类型化数组
      let byteArray = new Uint8Array(bytesCode)

      // 将base64转换为ascii码
      for (let i = 0; i < bytes.length; i++) {
        byteArray[i] = bytes.charCodeAt(i)
      }
      // 生成Blob对象（文件对象）
      return new Blob([bytesCode], { type: imgtype })
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      //  console.log(jsonData)
      //  console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          requestDownLoadFile({ Id: item.fid }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.fid }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.fid }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
      } else {
        this.isLoading = false
        this.$message.error('不支持此文件预览')
      }
    },

    async down(item) {
      //下载
      this.isLoading = true
      const res = await downfile({
        Id: item.fid
      })
      if (res.status == '201') {
        this.$message.error('找不到文件')
        this.isLoading = false
        return
      }
      // console.log(res)
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
        this.GetLog()
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      this.isLoading = false
      fileReader.readAsText(data)
    },

    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null

      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name + '.' + fileType)
        this.isLoading = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },

    // 时间格式
    handleTime(time, format) {
      if (time == null || time == undefined || time == '') {
        return ''
      }
      var t = new Date(time.toString().replace(/-/g, '/'))
      var tf = function (i) {
        return (i < 10 ? '0' : '') + i
      }
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case 'yyyy':
            return tf(t.getFullYear())
            break
          case 'MM':
            return tf(t.getMonth() + 1)
            break
          case 'mm':
            return tf(t.getMinutes())
            break
          case 'dd':
            return tf(t.getDate())
            break
          case 'HH':
            return tf(t.getHours())
            break
          case 'ss':
            return tf(t.getSeconds())
            break
        }
      })
    },
    // 获取文件后缀
    getFileType(name) {
      if (name) {
        if (name.lastIndexOf('.') > -1) {
          return name.slice(name.lastIndexOf('.') + 1)
        } else {
          return false
        }
      }
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },
    GetProcess() {
      CaseProcess({ SealId: this.SealId }).then((res) => {
        if (res.data.status == 'success') {
          this.Process = res.data.data
        } else if (
          res.status == '401' ||
          res.status == '402' ||
          res.status == '403'
        ) {
          this.$message.error(res.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    }
  },
  created() {
    this.getvalue()
    this.SealId = this.$route.query.guid
    this.GetSealDetail()
    this.GetLog()
    this.GetProcess()
    this.Successlog()
  },
  computed: {}
}
</script>
  
<style lang="less" scoped>
#sealDetail .contain {
  width: 90%;
  margin: auto;
}

#sealDetail .input {
  width: 50%;
}

.right {
  width: 80%;
  margin: auto;
}

#sealDetail /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#sealDetail .footer {
  width: 100%;
  margin: auto;
  text-align: center;
}

#sealDetail .history {
  border: 1px solid #2bc887;
  color: #2bc887;
}
#sealDetail .dayinbtn {
  border: 1px solid #2ba3c8;
  color: #2ba3c8;
}
// 附件回显
#sealDetail .upload_file {
  width: 360px;
}

#sealDetail .file_show {
  width: 360px;
}

#sealDetail .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#sealDetail img {
  width: 100%;
  height: 100%;
}

#sealDetail .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}

#sealDetail .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#sealDetail /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#sealDetail .look {
  color: #fe964a;
  margin-right: 10px;
}

#sealDetail .down {
  color: #2bc887;
  margin-right: 10px;
}

#sealDetail .del {
  color: hsl(356, 93%, 50%);
}

#sealDetail .word {
  line-height: 24px;
  cursor: default;
}

//进度条
#sealDetail .uploadprocess {
  width: 360px;
}

#sealDetail .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#sealDetail .jdtext {
  width: 360px;
  display: flex;
}

#sealDetail .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}

// 打印
.dayin {
  // width: 50%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-family: '宋体';
  display: none;
  min-width: 300px;
  .chenghu {
    text-decoration: underline;
    display: inline-block;
    min-width: 300px;
  }
  #casetable {
    width: 557px;
    margin: 0 auto;
    font-family: '宋体';
    line-height: 50px;
    font-size: 18.6px;
  }

  #casetable .center_font {
    text-align: center;
  }

  #casetable .case_title {
    font-size: 26px;
    font-weight: bold;
    font-weight: 500;
  }

  .case_code {
    font-size: 18.6px;
  }

  .input_con {
    border-bottom: 1px solid #333;
    width: 180px;
    display: inline-block;
  }

  .input_shortcon {
    border-bottom: 1px solid #333;
    width: 10%;
    display: inline-block;
  }

  .case_span_border {
    border-bottom: 1px solid #333;
  }

  .case_row {
    height: 40px;
  }

  .text-right {
    text-align: right;
  }

  .text_space {
    text-indent: 2em;
  }

  .text_center {
    text-align: center;
  }

  .qrcode {
    /*二维码*/
    margin-left: 14px;
  }

  .case_tb {
    width: 100%;
    height: 700px; /*overflow:hidden;*/
  }

  table tr .td_l {
    width: 20%;
    // font-size: 22px;
    // font-weight: bold;
    text-align: center;
    line-height: 22px;
  }

  table tr .td_r {
    width: 30%;
    font-size: 20px !important;
    text-align: center;
    line-height: 22px;
  }

  .td_gy {
    height: 80px;
  }

  .td_hhr {
    height: 70px;
  }

  table tr td label {
    float: left;
    line-height: 30px;
    width: 45%;
  }

  table tr td label input {
    vertical-align: middle;
    height: 18px;
    width: 19px;
  }

  table tr td label span {
    vertical-align: middle;
    color: #333;
    font-weight: 100;
  }

  .td_rs {
    padding: 0 20px;
  }

  table tr td p {
    width: 100%;
    line-height: 22px;
    font-size: 15px;
    padding: 0 2%;
    margin-bottom: 5px;
    color: #666;
    float: left;
    text-align: left;
  }

  table tr td p .case_span_border {
    min-width: 50%;
  }

  #Print_btn {
    float: right;
    margin-bottom: 25px;
    line-height: 25px;
    margin-left: 15px;
  }

  #FenSuoChange {
    float: right;
    margin-bottom: 25px;
    height: 31px;
  }

  .AdmissibleInstitution_span {
    display: inline-block;
    min-width: 45%;
    line-height: 20px;
    margin-left: 40px;
  }

  .td_zhu {
    font-size: 12px;
  }

  .td_p_date {
    width: 40%;
    float: right;
    font-size: 20px;
    text-align: right;
  }

  table tr .td_gaiyao {
    text-align: left;
    text-indent: 40px;
  }

  table tr .td_time {
    text-align: right;
  }

  .minwidth {
    min-width: 0;
  }

  .han_margintop {
    margin-top: 30px;
  }
}

.lsdialog {
  text-align: center;
  display: flex;
  padding-top: 1%;
  padding-left: 18%;
}
.printenter {
  text-align: center;
  padding-top: 10%;
}
.checkbox-label {
  display: flex;
  align-items: center;
  width: 45%;
}

.checkbox-label input[type='checkbox'] {
  margin-right: 5px;
  width: 16px; /* 调整复选框的宽度 */
  height: 16px; /* 调整复选框的高度 */
  transform: scale(0.8); /* 调整复选框的大小 */
}

.checkbox-label input[type='checkbox']:checked {
  background-color: rgb(226, 29, 39); /* 调整选中的样式颜色 */
}

.glbtn {
  border: none;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  padding: 13px 0px;
}
</style>
  